// src/components/HomeView.jsx
import { useState } from 'react';

export default function HomeView({ matters, onNewMatter, onSelectMatter }) {
  const awaiting = matters.filter(m => m.status === 'pending');
  const active   = matters.filter(m => m.status === 'active');
  const lastActive = active.sort((a,b) => new Date(b.updated_at) - new Date(a.updated_at))[0];

  return (
    <div style={{
      flex: 1, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '60px 40px', minHeight: '100vh',
    }}>
      {/* Brand */}
      <div style={{ textAlign: 'center', marginBottom: 56 }}>
        <div style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontSize: 82, fontWeight: 500, color: '#0D1B2A',
          letterSpacing: '-0.02em', lineHeight: 1,
        }}>
          LitFit<span style={{ fontSize: 30, fontWeight: 400, verticalAlign: 'super', color: '#C8A84B' }}>™</span>
        </div>
        <div style={{ fontSize: 12, fontWeight: 300, color: '#BBB', marginTop: 14, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
          Litigation fitness analysis for Australian legal practitioners
        </div>
        <div style={{ fontSize: 12, fontWeight: 300, color: '#C8A84B', marginTop: 10, letterSpacing: '0.02em' }}>
          LitFit identifies opportunities to strengthen your case — not errors in your work.
        </div>
      </div>

      {/* Action cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, width: '100%', maxWidth: 800 }}>

        {/* New matter */}
        <ActionCard
          onClick={onNewMatter}
          icon={
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M9 3v12M3 9h12" stroke="#0D1B2A" strokeWidth="1.6" strokeLinecap="round"/>
            </svg>
          }
          iconBg="rgba(13,27,42,0.07)"
          question="Is my case fit for litigation?"
          desc="Type the matter name, drag in your documents, and run your first LitFit™ fitness analysis"
          action="New matter →"
        />

        {/* Re-analyse */}
        <ActionCard
          onClick={() => lastActive && onSelectMatter(lastActive.matter_id)}
          icon={
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M5 3.5l10 5.5-10 5.5V3.5z" fill="#C8A84B"/>
            </svg>
          }
          iconBg="rgba(200,168,75,0.12)"
          question="How fit is my litigation?"
          desc={lastActive ? `Re-analyse ${lastActive.matter_name} or open another matter` : "Re-analyse an existing matter with updated pleadings, evidence, submissions or strategy context"}
          action="Open existing matter →"
        />

        {/* Awaiting */}
        <ActionCard
          onClick={() => awaiting.length && onSelectMatter(awaiting[0].matter_id)}
          icon={
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="9" cy="9" r="7" stroke="#C8A84B" strokeWidth="1.3"/>
              <path d="M9 5.5v4l2.5 2" stroke="#C8A84B" strokeWidth="1.3" strokeLinecap="round"/>
            </svg>
          }
          iconBg="rgba(200,168,75,0.08)"
          question={
            <span style={{ fontStyle: 'normal', fontSize: 16, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>
              Awaiting{' '}
              <span style={{ display: 'inline-block', background: 'rgba(200,168,75,0.15)', color: '#C8A84B', fontSize: 11, fontWeight: 500, padding: '2px 7px', borderRadius: 10 }}>
                {awaiting.length}
              </span>
            </span>
          }
          desc={awaiting.length
            ? `${awaiting.map(m => m.matter_name).slice(0,2).join(' and ')} ${awaiting.length > 2 ? `and ${awaiting.length - 2} more are` : awaiting.length === 1 ? 'is' : 'are'} awaiting documents or instructions`
            : 'No matters currently awaiting documents'}
          action="Complete matter →"
        />
      </div>
    </div>
  );
}

function ActionCard({ onClick, icon, iconBg, question, desc, action }) {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: '#FFF',
        border: `1px solid ${hover ? '#C8A84B' : '#E8E4DC'}`,
        borderRadius: 12, padding: '30px 26px',
        cursor: 'pointer',
        transform: hover ? 'translateY(-2px)' : 'none',
        boxShadow: hover ? '0 8px 28px rgba(0,0,0,0.07)' : 'none',
        transition: 'all 0.2s', textAlign: 'left',
      }}
    >
      <div style={{ width: 38, height: 38, borderRadius: 9, marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', background: iconBg }}>
        {icon}
      </div>
      <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 17, fontWeight: 400, fontStyle: 'italic', color: '#0D1B2A', marginBottom: 10, lineHeight: 1.3 }}>
        {question}
      </div>
      <div style={{ fontSize: 12.5, color: '#AAA', fontWeight: 300, lineHeight: 1.55 }}>{desc}</div>
      <div style={{ fontSize: 12, fontWeight: 500, color: '#C8A84B', marginTop: 16, letterSpacing: '0.03em' }}>{action}</div>
    </div>
  );
}
